// components/TelebirrDepositModal.jsx
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api } from "../api";
import { parseJWT } from "../utils/jwtUtils";

const TelebirrDepositModal = ({ onClose }) => {
  const [amount, setAmount] = useState("");
  const [receiptNumber, setReceiptNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCheck = async () => {
    if (!amount.trim()) {
      toast.error("Please enter sent Amount!");
      return;
    }
    if (!receiptNumber.trim()) {
      toast.error("Please enter your Telebirr receipt number!");
      return;
    }

    try {
      setIsLoading(true);

      // same auth pattern as ConfirmCardPage
      const stored = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null;

      const userInfo = parseJWT(stored?.token);

      if (!userInfo) {
        toast.error("User not authenticated!");
        setIsLoading(false);
        return;
      }

      const response = await api.post("/verify-manual-deposit", {
        reference: receiptNumber.trim(),
        phoneNumber: userInfo.phone,
        amount: amount,
      });

      if (response.data?.success === true) {
        // optional local balance update
        if (response.data.newBalance) {
          localStorage.setItem("balance", response.data.newBalance);
        }

        toast.success(
          response.data.message || "Transaction verified successfully!",
        );

        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        toast.error(
          response.data.message || "Transaction not found or invalid.",
        );
      }
    } catch (error) {
      console.error("VERIFY ERROR:", error);

      toast.error(
        error.response?.data?.message ||
          "Error verifying transaction. Try again!",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const phone = "0952590694";
  const name = "አደራጀው";

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(phone);

      // ✅ Optional: store for reuse anywhere
      localStorage.setItem("copiedPhone", phone);

      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <div className="fixed inset-0 bg-primary bg-opacity-70 flex items-center justify-center z-[9999]">
      <div className="bg-primary text-white rounded-lg shadow-2xl w-[420px] border border-blue-900 relative animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-white text-2xl hover:text-gray-300"
        >
          ✕
        </button>

        {/* Header */}
        <div className="bg-[#134454] px-4 py-2 rounded-t-lg border-b border-[#1a4a8e] text-center">
          <h2 className="text-md font-semibold font-serif">
            Telebirr Transfer Deposit
          </h2>
        </div>

        {/* Body */}
        <div className="px-5 py-4 text-[15px] leading-relaxed">
          <p className="text-yellow-400 font-medium mb-2 font-serif">
            ማስገባት የፈለጉትን የገንዘብ መጠን ከእርስዎ ቴሌብር ወደ 0952590694 (አደራጀው) ይላኩ።
          </p>

          {/* <ol className="list-decimal list-inside text-white space-y-1 mt-2 font-serif">
            <li>Telebirr App ወይም *127# ገብተው</li>
            <li>ስልክ ቁጥሩ ላይ ትራንስፈር ያርጉ</li>
            <li>
              Transaction Checker ውስጥ ገብተው የክፍያ ቁጥር ( Transaction Number ) ቁጥር
              ያስገቡ
            </li>
          </ol> */}

          {/* Info Box */}
          <div className="bg-white text-[#0d2d61] rounded-md px-4 py-3 mt-4">
            <div className="flex justify-between">
              <span className="font-semibold">ስልክ ቁጥር፡</span>
              <span className="font-bold">0952590694</span>
            </div>
            <div className="flex justify-between mt-1">
              <span className="font-semibold">ስም፡</span>
              <span>አደራጀው</span>
            </div>
          </div>
          {/* 🔘 Copy Button */}
          <button
            onClick={handleCopy}
            className="mt-1 w-full bg-[#134454] text-white py-1 rounded-md hover:bg-[#434454]"
          >
            {copied ? "Copied ✅" : "Copy Phone Number"}
          </button>
          <p className="text-red-500 text-sm mt-3 text-center font-medium font-serif">
            ትራንስፈር የምታረጉበት ቁጥር ዘመድ ቢንጎ አካውንቶ ቁጥር ጋር አንድ አይነት መሆን አለበት። ገቢ የሚሆነው
            በላኩበት ቁጥር ብቻ ነው።
          </p>

          {/* Transaction Input */}
          <div className="bg-[#134454] mt-4 p-3 rounded-md border border-[#1a4a8e] font-serif">
            <h3 className="text-white font-semibold text-sm mb-1">
              ወደ 0952590694 (አደራጀው) ትራንስፈር ያረጉት የብር መጠን ወደ ዘመድ ቢንጎ ዋሊት አካውንትዎ
              ያስገቡ።
            </h3>

            <label className="block text-sm mb-1">የላኩትን ገንዘብ ይመዝግቡ</label>
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="00.o"
              className="w-full px-3 py-2 rounded-md text-gray-900 text-sm focus:outline-none"
            />
            <label className="block text-sm mb-1">Transaction ቁጥር ያስገቡ</label>
            <input
              type="text"
              value={receiptNumber}
              onChange={(e) => setReceiptNumber(e.target.value)}
              placeholder="Transaction Number ለምሳሌ: SB080WSFGH"
              className="w-full px-3 py-2 rounded-md text-gray-900 text-sm focus:outline-none"
            />

            <button
              onClick={handleCheck}
              disabled={isLoading}
              className={`w-full mt-4 bg-gradient-to-r from-red-500 to-cyan-600 hover:from-blue-700 hover:to-indigo-800 text-white py-2 rounded-md transition font-semibold flex items-center justify-center ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                <div className="flex items-center space-x-2">
                  <span className="animate-spin border-2 border-t-transparent border-white rounded-full w-4 h-4"></span>
                  <span>Checking...</span>
                </div>
              ) : (
                "ገቢ ያድርጉ"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default TelebirrDepositModal;
